<mat-card>
  <mat-card-header>
    <mat-card-title>POSITIONS</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="positions" class="center" matSort matSortDisableClear>
      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Position</th>
        <td class="user-cell" mat-cell *matCellDef="let position">
          <mat-chip>
            {{position.baer_role.text}}
          </mat-chip>
        </td>
      </ng-container>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
        <td mat-cell *matCellDef="let position">
          @if(position.location_id == 2){WO}
          @else {{{position.region}}}
        </td>
      </ng-container>
      <ng-container matColumnDef="forest">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Forest Name</th>
        <td mat-cell *matCellDef="let position">
          @if(position.location_id == 0){{{position.forest_name}}}
          @else {--}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="3">
          <div class="no-data">
            <div class="no-data-icon">
              <mat-icon class="no-data-icon1">search</mat-icon>
              <fa-icon [icon]="faFire" class="no-data-icon2"></fa-icon>
            </div>
            <div class="no-data-title">No Positions</div>
            <p>There are no positions for this user.</p>
          </div>
        </td>
      </tr>
    </table>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons
      aria-label="Select page of positions">
    </mat-paginator>
  </mat-card-content>
</mat-card>